export default class IAARAddressDTO {

    address1: string | null = null;
    address2: string | null = null;
    city: string | null = null;
    state: string | null = null;
    zipCode: string | null = null;

}
